/**
 * Why is this not an arrow function?
 * @see https://github.com/microsoft/TypeScript/issues/34523
 */
export function assert (value: unknown, error: Error): asserts value {
    if (!value) {
        throw error
    }
}
